/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetOrgProjectCountQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
  orgMember: Types.Scalars["Boolean"]["input"];
}>;

export type GetOrgProjectCountQuery = {
  readonly __typename: "Query";
  readonly orgById?: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly projectCount: number;
  };
};

export const GetOrgProjectCountDocument = /*#__PURE__*/ gql`
  query GetOrgProjectCount($orgId: OrgId!, $orgMember: Boolean!) {
    orgById(orgId: $orgId) @include(if: $orgMember) {
      id
      projectCount
    }
  }
`;

/**
 * __useGetOrgProjectCountQuery__
 *
 * To run a query within a React component, call `useGetOrgProjectCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgProjectCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgProjectCountQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      orgMember: // value for 'orgMember'
 *   },
 * });
 */
export function useGetOrgProjectCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrgProjectCountQuery,
    GetOrgProjectCountQueryVariables
  > &
    (
      | { variables: GetOrgProjectCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrgProjectCountQuery,
    GetOrgProjectCountQueryVariables
  >(GetOrgProjectCountDocument, options);
}
export function useGetOrgProjectCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrgProjectCountQuery,
    GetOrgProjectCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrgProjectCountQuery,
    GetOrgProjectCountQueryVariables
  >(GetOrgProjectCountDocument, options);
}
export function useGetOrgProjectCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrgProjectCountQuery,
    GetOrgProjectCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrgProjectCountQuery,
    GetOrgProjectCountQueryVariables
  >(GetOrgProjectCountDocument, options);
}
export type GetOrgProjectCountQueryHookResult = ReturnType<
  typeof useGetOrgProjectCountQuery
>;
export type GetOrgProjectCountLazyQueryHookResult = ReturnType<
  typeof useGetOrgProjectCountLazyQuery
>;
export type GetOrgProjectCountSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgProjectCountSuspenseQuery
>;
export type GetOrgProjectCountQueryResult = Apollo.QueryResult<
  GetOrgProjectCountQuery,
  GetOrgProjectCountQueryVariables
>;
